import { Box } from '@mui/material';
import styled from 'styled-components';
import Home from '../components/organism/home/home';

const PageWrapper = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8f5f2;
`;

const Index = () => {
  return (
      <PageWrapper>
        <Home/>
      </PageWrapper>
  );
};

export default Index;